import HomeBackdrop from "@/components/public/home/HomeBackdrop";
import HeroSection from "@/components/public/home/HeroSection";
import StatsStrip from "@/components/public/home/StatsStrip";
import ServicesTimeline from "@/components/public/home/ServicesTimeline";
import FlagshipsTimeline from "@/components/public/home/FlagshipsTimeline";
import ProcessWithVideos from "@/components/public/home/ProcessWithVideos";
import BlogTimeline from "@/components/public/home/BlogTimeline";
import FounderSection from "@/components/public/home/FounderSection";
import MegaCTA from "@/components/public/home/MegaCTA";
import { SEO, organizationJsonLd, websiteJsonLd } from "@/lib/seo";

const Home = () => {
    return (
        <>
            <SEO
                title="TRBD — حلول رقمية لتطوير الأعمال"
                description="نبني منصات رقمية متكاملة: متاجر، تطبيقات، وأنظمة إدارة. أكثر من 45 مشروعاً و102 عميلاً حول العالم."
                path="/"
                keywords={[
                    "TRBD",
                    "تطوير مواقع",
                    "تطبيقات جوال",
                    "حلول رقمية",
                    "تصميم متاجر إلكترونية",
                    "أحمد اللولو",
                    "Kasioon",
                    "CarWhats",
                ]}
                jsonLd={[organizationJsonLd(), websiteJsonLd()]}
            />
            {/* Shared 3D globe backdrop — fixed to the viewport behind every section
                so the whole home page reads as one continuous journey. */}
            <HomeBackdrop />
            <div className="relative z-10 flex flex-col">
                <HeroSection />
                <StatsStrip />
                <ServicesTimeline />
                <FlagshipsTimeline />
                <ProcessWithVideos />
                <BlogTimeline />
                <FounderSection />
                <MegaCTA />
            </div>
        </>
    );
};

export default Home;
